import { Grid } from '@material-ui/core';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  topOuterDivider: PropTypes.bool,
  topDivider: PropTypes.bool
}

const defaultProps = {
  topOuterDivider: false,
  topDivider: false
}

const Footer = ({
  className,
  topOuterDivider,
  topDivider,
  ...props
}) => {

  const classes = classNames(
    'site-footer center-content-mobile',
    topOuterDivider && 'has-top-divider',
    className
  );

  return (
    <footer
      {...props}
      className={classes}
    >
      <div className="container">
        <div className={
          classNames(
            'site-footer-inner',
            topDivider && 'has-top-divider'
          )}>
          <div className="footer-top space-between text-xxs">
            <Grid container spacing={1} style={{ textAlign: "left" }} direction="row" justifyContent="flex-end" alignItems="flex-end">
              <Grid item md={3} sm={"12"}>
                <img
                  src={require('../../assets/images/SiloVirtual.png')}
                  alt="Open"
                  style={{ height: "60%" }}
                />
              </Grid>

              <Grid item md={4} sm={"12"}>
                
              </Grid>

              <Grid item md={4} sm={"12"}>
                <b>Endereço</b>
                <p>Rua Colonizador Ênio Pipino, N° 3000. Sala 213 - St. Industrial Norte CEP: 78550-514 - Sinop - MT</p>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </footer>
  );
}

Footer.propTypes = propTypes;
Footer.defaultProps = defaultProps;

export default Footer;